<div class="row no-gutters" style="margin-right: 1.875rem">
  <div mat-dialog-title class="col d-flex align-items-center">
    <img
      *ngIf="isPreferred"
      src="assets/svg/ico_heart_red.svg"
      alt="Preferred Location"
      width="16"
      class="mr-2"
    />
    <span
      class="camp-name oswald"
      [ngClass]="{
        primary: isPreferred,
        teal: !isPreferred
      }"
      >{{ locationData.name }}</span
    >
  </div>
  <button mat-dialog-close class="col-auto btn-close-dialog">
    <fa-icon [icon]="faTimes" size="lg"></fa-icon>
  </button>
</div>
<mat-dialog-content>
  <div class="camp-details-section-container">
    <div class="section-title lato bold">Location</div>
    <a
      [href]="
        googleMapsService.getDirectionsUrl(
          locationData.address1 +
            ' ' +
            locationData.address2 +
            ', ' +
            locationData.city +
            ', ' +
            locationData.state +
            ' ' +
            locationData.zipcode
        )
      "
      target="_blank"
      class="section-content lato bold"
    >
      {{ locationData.address1 }}<br />
      {{ locationData.address2 }}<br *ngIf="locationData.address2" />
      {{ locationData.city }}, {{ locationData.state }}
      {{ locationData.zipcode }}
    </a>
    <div class="section-divider"></div>
    <div class="section-title lato bold">Phone</div>
    <a
      [href]="'tel:' + locationData.telephone"
      class="section-content lato bold"
      >{{ locationData.telephone | phoneNumber }}</a
    >
    <div class="section-divider"></div>
    <div class="section-title lato bold">Hours</div>
    <div
      class="row no-gutters mb-3 lato"
      *ngFor="let dayOfTheWeek of locationHours"
    >
      <div class="col-4 day">{{ dayOfTheWeek.day | titlecase }}</div>
      <div class="col-8">
        <div
          *ngFor="let hours of dayOfTheWeek.times"
          class="hours"
          [ngClass]="{ closed: hours === 'Closed' }"
        >
          {{ hours }}
        </div>
      </div>
    </div>

    <div class="section-divider"></div>

    <div *ngIf="locationData.code" class="arrow-link-container">
      <app-arrow-link-right
        text="Watch Camper Cams&#8480;"
        [useLato]="true"
        (handleClick)="navigateToCamperCams()"
      ></app-arrow-link-right>
    </div>
    <div *ngIf="locationData.websiteUrl" class="arrow-link-container">
      <app-arrow-link-right
        text="Visit Website"
        [useLato]="true"
        (handleClick)="navigateToCampWebsite()"
      ></app-arrow-link-right>
    </div>
    <div class="arrow-link-container">
      <a
        [href]="
          'mailTo:' +
          locationData.email +
          '?subject=Inquiry from Camp Bow Wow Client Portal'
        "
        target="_blank"
      >
        <app-arrow-link-right
          text="Email Camp"
          [useLato]="true"
        ></app-arrow-link-right>
      </a>
    </div>
  </div>
  <div class="row no-gutters">
    <div class="col-12 col-sm-6 mb-2 mb-sm-0 pr-sm-1">
      <button
        class="btn btn-danger btn-block dialog-footer-action btn-height-auto"
        (click)="navigateToReservation()"
      >
        Book a Reservation
      </button>
    </div>
    <div class="col-12 col-sm-6 pl-sm-1">
      <button
        class="btn btn-outline-danger btn-block dialog-footer-action btn-height-auto"
        (click)="navigateToInterviewRequest()"
      >
        Request an Interview
      </button>
    </div>
  </div>
</mat-dialog-content>
